export default __webpack_public_path__ + "static/1-317b175c48007277744e512e3d8dac07.jpg";